// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__STE_b","contentBody1":"style_contentBody1__pgWDB","contentBody2":"style_contentBody2__P7kcL","contentAppBody1":"style_contentAppBody1__Xj4l4"};